import { defineComponent as i, computed as r, openBlock as u, createElementBlock as m, normalizeClass as l, createElementVNode as d, toDisplayString as p } from "vue";
const b = ["data-name"], g = { class: "pagination-number-text" }, k = /* @__PURE__ */ i({
  __name: "BasePaginationNumber",
  props: {
    number: {},
    status: { default: "unselected" }
  },
  emits: ["click"],
  setup(t, { emit: a }) {
    const n = t, s = a, c = () => {
      s("click", n.number);
    }, o = r(() => {
      const e = "pagination-number";
      switch (n.status) {
        case "selected":
          return `${e} pagination-number-selected`;
        case "hover":
          return `${e} pagination-number-hover`;
        default:
          return `${e} pagination-number-unselected`;
      }
    });
    return (e, h) => (u(), m("div", {
      class: l(o.value),
      onClick: c,
      "data-name": `Pagination/Number-${t.status}`
    }, [
      d("span", g, p(t.number), 1)
    ], 10, b));
  }
});
export {
  k as default
};
